import React, { useMemo, useState } from 'react';
import "../assets/style/deposit.scss";
import "../assets/style/withdraw.scss";
import { Form, Image, Spinner } from "react-bootstrap";
import { Dai, Usdt, Usdc, Ethereum, Btc } from 'react-web3-icons';
import { MdOutlineSecurity } from "react-icons/md"
import { FaEthereum } from "react-icons/fa"
import toIcn from "../assets/images/logo.svg"
import { useAccount, useConnect, useNetwork, useSwitchNetwork, useBalance } from 'wagmi'
import { InjectedConnector } from 'wagmi/connectors/injected';
import { IoMdWallet } from "react-icons/io"
import { HiSwitchHorizontal } from "react-icons/hi";
import metamask from "../assets/images/metamask.svg"
import TabMenu from './TabMenu';
import { withdrawETH, withdrawERC20 } from '../utils/bridge';
import { createL2PublicClient } from '../utils/viemClient';
// 辅助函数：清理环境变量值（去除注释和空格）
const cleanEnvValue = (value) => {
  if (!value) return value;
  // 去除注释（# 及其后面的内容）
  const cleaned = String(value).split('#')[0].trim();
  return cleaned;
}

const Withdraw = () => {
  // 从环境变量获取链ID，确保是数字类型
  const L1_CHAIN_ID = Number(cleanEnvValue(process.env.REACT_APP_L1_CHAIN_ID)) || 11155111; // 默认 Sepolia
  const L2_CHAIN_ID = Number(cleanEnvValue(process.env.REACT_APP_L2_CHAIN_ID));

  const [ethValue, setEthValue] = useState("")
  const [sendToken, setSendToken] = useState("ETH")
  const [errorInput, setErrorInput] = useState("")
  const [checkMetaMask, setCheckMetaMask] = useState("");
  const [loader, setLoader] = useState(false)
  const { address, isConnected } = useAccount()
  const { chain, chains } = useNetwork()
  const { connect } = useConnect({
    connector: new InjectedConnector({ chains }), onError(error) {
      console.log('Error', error)
    },
    onMutate(args) {
      console.log('Mutate', args)
      if (args.connector.ready === true) {
        setCheckMetaMask(false)
      } else {
        setCheckMetaMask(true)
      }
    },
    onSettled(data, error) {
      console.log('Settled', { data, error })
    },
    onSuccess(data) {
      console.log('Success', data)
    },
  })
  const [metaMastError, setMetaMaskError] = useState("")
  const l2PublicClient = useMemo(() => {
    try {
      return createL2PublicClient()
    } catch (error) {
      console.error('初始化 L2 Public Client 失败:', error)
      return null
    }
  }, [])
  const tokenConfig = useMemo(() => ({
    ETH: { decimals: 18 },
    DAI: {
      l1: process.env.REACT_APP_L1_DAI,
      l2: process.env.REACT_APP_L2_DAI,
      decimals: 18
    },
    USDT: {
      l1: process.env.REACT_APP_L1_USDT,
      l2: process.env.REACT_APP_L2_USDT,
      decimals: 6
    },
    USDC: {
      l1: process.env.REACT_APP_L1_USDC,
      l2: process.env.REACT_APP_L2_USDC,
      decimals: 6
    },
    wBTC: {
      l1: process.env.REACT_APP_L1_wBTC,
      l2: process.env.REACT_APP_L2_wBTC,
      decimals: 8
    }
  }), [])
  const { switchNetwork } = useSwitchNetwork({
    // throwForSwitchChainNotSupported: true,
    chainId: L2_CHAIN_ID,
    onError(error) {
      console.log('Error', error)
    },
    onMutate(args) {
      console.log('Mutate', args)
    },
    onSettled(data, error) {
      console.log('Settled', { data, error })
      try {
        const l2RpcUrl = cleanEnvValue(process.env.REACT_APP_L2_RPC_URL);
        const l2ExplorerUrl = cleanEnvValue(process.env.REACT_APP_L2_EXPLORER_URL);
        const l2NetworkName = cleanEnvValue(process.env.REACT_APP_L2_NETWORK_NAME) || "Custom L2";

        // 验证 RPC URL
        if (!l2RpcUrl) {
          setMetaMaskError("L2 RPC URL 未配置");
          return;
        }

        // MetaMask 要求 rpcUrls 必须是 HTTPS，如果是 HTTP 需要转换或提示
        let rpcUrls = [l2RpcUrl];
        if (l2RpcUrl.startsWith('http://')) {
          // 尝试将 HTTP 转换为 HTTPS（如果可能）
          // 注意：如果服务器不支持 HTTPS，这可能会失败
          const httpsUrl = l2RpcUrl.replace('http://', 'https://');
          console.warn('警告: RPC URL 是 HTTP，MetaMask 可能不接受。尝试使用 HTTPS:', httpsUrl);
          rpcUrls = [httpsUrl, l2RpcUrl]; // 提供两个选项
        }

        // 确保 blockExplorerUrls 是数组
        const blockExplorerUrls = l2ExplorerUrl ? [l2ExplorerUrl] : [];

        window.ethereum.request({
          method: "wallet_addEthereumChain",
          params: [{
            chainId: (function(dec) {
              if (!dec || isNaN(dec)) {
                throw new Error('Invalid chain ID');
              }
              return `0x${parseInt(dec, 10).toString(16)}`;
            })(L2_CHAIN_ID),
            rpcUrls: rpcUrls,
            chainName: l2NetworkName,
            nativeCurrency: {
              name: process.env.REACT_APP_L2_NATIVE_CURRENCY_NAME || "ETHEREUM",
              symbol: process.env.REACT_APP_L2_NATIVE_CURRENCY_SYMBOL || "ETH",
              decimals: 18
            },
            blockExplorerUrls: blockExplorerUrls
          }]
        }).then((data) => {
          setMetaMaskError("")
        }).catch((err) => {
          console.error('添加链失败:', err);
          if (err.code === -32002) {
            setMetaMaskError("请求卡在待处理状态，请检查 MetaMask")
          } else if (err.message && err.message.includes('HTTPS')) {
            setMetaMaskError("错误: MetaMask 要求 RPC URL 必须是 HTTPS。请将 REACT_APP_L2_RPC_URL 改为 HTTPS 地址")
          } else {
            setMetaMaskError(`添加链失败: ${err.message || err.code || '未知错误'}`)
          }
        });
      }
      catch (error) {
        console.error('添加链异常:', error);
        setMetaMaskError(`配置错误: ${error.message}`)
      }
    },
    onSuccess(data) {
      console.log('Success', data)

    },
  })
  //========================================================== BALANCES =======================================================================

  const { data } = useBalance({ address: address, chainId: L2_CHAIN_ID, watch: true })
  // 添加 enabled 选项，只有在地址和代币地址都有效时才查询，避免无效合约地址错误
  const dataUSDT = useBalance({
    address: address,
    chainId: L2_CHAIN_ID,
    token: process.env.REACT_APP_L2_USDT,
    watch: true,
    enabled: !!address && !!process.env.REACT_APP_L2_USDT,
  });
  const dataDAI = useBalance({
    address: address,
    chainId: L2_CHAIN_ID,
    token: process.env.REACT_APP_L2_DAI,
    watch: true,
    enabled: !!address && !!process.env.REACT_APP_L2_DAI,
  });
  const dataUSDC = useBalance({
    address: address,
    chainId: L2_CHAIN_ID,
    token: process.env.REACT_APP_L2_USDC,
    watch: true,
    enabled: !!address && !!process.env.REACT_APP_L2_USDC,
  });
  const datawBTC = useBalance({
    address: address,
    chainId: L2_CHAIN_ID,
    token: process.env.REACT_APP_L2_wBTC,
    watch: true,
    enabled: !!address && !!process.env.REACT_APP_L2_wBTC,
  });

  ////========================================================== WITHDRAW =======================================================================

  const handleWithdraw = async () => {
    if (!address) {
      setErrorInput("Please connect your wallet first.")
      return
    }
    if (!ethValue) {
      setErrorInput("Please enter the amount")
      return
    }
    if (!(parseFloat(ethValue) > 0)) {
      setErrorInput("Invalid Amount Entered!")
      return
    }

    const tokenMeta = tokenConfig[sendToken] || tokenConfig.ETH
    if (sendToken !== 'ETH' && (!tokenMeta?.l1 || !tokenMeta?.l2)) {
      setErrorInput(`${sendToken} token addresses are not configured`)
      return
    }

    setLoader(true)
    setErrorInput("")

    try {
      let hash
      if (sendToken === "ETH") {
        console.log('[Withdraw] Sending withdrawETH request', {
          amount: ethValue,
          address,
          l2Bridge: process.env.REACT_APP_L2_BRIDGE || '0x4200000000000000000000000000000000000010'
        })
        hash = await withdrawETH(ethValue, address)
      } else {
        console.log('[Withdraw] Sending withdrawERC20 request', {
          token: sendToken,
          amount: ethValue,
          address,
          l1Token: tokenMeta.l1,
          l2Token: tokenMeta.l2
        })
        hash = await withdrawERC20(
          tokenMeta.l1,
          tokenMeta.l2,
          ethValue,
          tokenMeta.decimals,
          address
        )
      }

      if (l2PublicClient && hash) {
        await l2PublicClient.waitForTransactionReceipt({ hash })
      }

      setEthValue("")
    } catch (error) {
      console.error('[Withdraw] Failed to send transaction', {
        error,
        message: error?.message,
        shortMessage: error?.shortMessage,
        cause: error?.cause,
        stack: error?.stack
      })
      setErrorInput(error?.shortMessage || error?.message || "Withdraw failed")
    } finally {
      setLoader(false)
    }
  }

  const handleSwitch = () => {
    try {
      if (!L2_CHAIN_ID || isNaN(L2_CHAIN_ID)) {
        console.error('L2_CHAIN_ID is not valid:', process.env.REACT_APP_L2_CHAIN_ID);
        return;
      }
      switchNetwork(L2_CHAIN_ID)
    }
    catch (error) {
      console.log(error);
    }
  }
  ////========================================================== HANDLE CHANGE =======================================================================
  const [checkDisabled, setCheckDisabled] = useState(false)

  const handleChange = (e) => {
    if (sendToken === "ETH") {
      if (Number(data?.formatted) < Number(e.target.value)) {
        setCheckDisabled(true)
        setErrorInput("Insufficient ETH balance.")
      } else {
        setCheckDisabled(false)
        setErrorInput("")
      }
      setEthValue(e.target.value)
    }
    if (sendToken === "DAI") {
      if (Number(dataDAI.data?.formatted) < e.target.value) {
        setCheckDisabled(true)
        setErrorInput("Insufficient DAI balance.")
      } else {
        setCheckDisabled(false)
        setErrorInput("")
      }
      setEthValue(e.target.value)
    }
    if (sendToken === "USDT") {
      if (Number(dataUSDT.data?.formatted) < e.target.value) {
        setCheckDisabled(true)
        setErrorInput("Insufficient DAI balance.")
      } else {
        setCheckDisabled(false)
        setErrorInput("")
      }
      setEthValue(e.target.value)
    }
    if (sendToken === "wBTC") {
      if (Number(datawBTC.data?.formatted) < e.target.value) {
        setCheckDisabled(true)
        setErrorInput("Insufficient wBTC balance.")
      } else {
        setCheckDisabled(false)
        setErrorInput("")
      }
      setEthValue(e.target.value)
    }
    if (sendToken === "USDC") {
      if (Number(dataUSDC.data?.formatted) < e.target.value) {
        setCheckDisabled(true)
        setErrorInput("Insufficient USDC balance.")
      } else {
        setCheckDisabled(false)
        setErrorInput("")
      }
      setEthValue(e.target.value)
    }
  }

  // ============= For Format balance =========================
  return (
    <>
      <div className='bridge_wrap'>
        <TabMenu />
        <section className='deposit_wrap'>
          <div className='withdraw_title_wrap'>
            <div className='withdraw_title_icn'>
              <MdOutlineSecurity />
            </div>
            <div className='withdraw_title_content'>
              <h3>Use the official bridge</h3>
              <p>This usually takes 7 days</p>
              <p>Bridge any token to Ethereum Sepolia</p>
            </div>
          </div>
          <div className='deposit_price_wrap'>
            <div className='deposit_price_title'>
              <p>From</p>
              <h5><Image src={toIcn} alt="To icn" fluid /> {process.env.REACT_APP_L2_NETWORK_NAME || "L2"}</h5>
            </div>
            <div className='deposit_input_wrap'>
              <Form>
                <div className='deposit_inner_input'>
                  <Form.Control type='number' name="eth_value" value={ethValue} onChange={handleChange} placeholder="0" min="0" step="any" />
                  <Form.Select
                    aria-label="Default select example"
                    className='select_wrap'
                    value="ETH"
                    disabled
                  >
                    <option value="ETH">ETH</option>
	          </Form.Select>
                </div>
                <div className='input_icn_wrap'>
                  {sendToken === "ETH" ? <span className='input_icn'><Ethereum style={{ fontSize: '1.5rem' }} /></span> : sendToken === "DAI" ? <span className='input_icn'><Dai style={{ fontSize: '1.5rem' }} /></span> : sendToken === "USDT" ? <span className='input_icn'><Usdt style={{ fontSize: '1.5rem' }} /></span> : sendToken === "wBTC" ? <span className='input_icn'><Btc style={{ fontSize: '1.5rem' }} /></span> : <span className='input_icn'><Usdc style={{ fontSize: '1.5rem' }} /></span>}
                </div>
              </Form>
            </div>
            {errorInput && <small className='text-danger'>{errorInput}</small>}
            {sendToken === "ETH" ? address && <p className='wallet_bal mt-2'>Balance: {Number(data?.formatted).toFixed(5)} ETH</p> : sendToken === "DAI" ? address && <p className='wallet_bal mt-2'>Balance: {Number(dataDAI.data?.formatted).toFixed(5)} DAI</p> : sendToken === "USDT" ? address && <p className='wallet_bal mt-2'>Balance: {Number(dataUSDT.data?.formatted).toFixed(5)} USDT</p> : sendToken === "wBTC" ? address && <p className='wallet_bal mt-2'>Balance: {Number(datawBTC.data?.formatted).toFixed(5)} wBTC</p> : <p className='wallet_bal mt-2'>Balance: {Number(dataUSDC.data?.formatted).toFixed(5)} USDC</p>}
          </div>
          <div className='deposit_details_wrap'>
            <div className="deposit_details">
              <p>To:</p>
              <h5><FaEthereum /> Sepolia Testnet</h5>
            </div>
            <div className='withdraw_bal_sum'>
              {sendToken === "ETH" ? <span className='input_icn'><Ethereum style={{ fontSize: '1.5rem' }} /></span> : sendToken === "DAI" ? <span className='input_icn'><Dai style={{ fontSize: '1.5rem' }} /></span> : sendToken === "USDT" ? <span className='input_icn'><Usdt style={{ fontSize: '1.5rem' }} /></span> : sendToken === "wBTC" ? <span className='input_icn'><Btc style={{ fontSize: '1.5rem' }} /></span> : <span className='input_icn'><Usdc style={{ fontSize: '1.5rem' }} /></span>}
              <p>You’ll receive: {ethValue ? ethValue : "0"} {sendToken}</p>
              <div></div>
              {/* <span className='input_title'>ETH</span> */}
            </div>
          </div>
          <div className="deposit_btn_wrap">
            {checkMetaMask === true ? <a className='btn deposit_btn' href='https://metamask.io/' target='_blank' rel='noreferrer'><Image src={metamask} alt="metamask icn" fluid /> Please Install Metamask Wallet</a> : !isConnected ? <button className='btn deposit_btn' onClick={() => connect()}><IoMdWallet />Connect Wallet</button> : chain.id !== L2_CHAIN_ID ? <button className='btn deposit_btn' onClick={handleSwitch}><HiSwitchHorizontal />Switch to {process.env.REACT_APP_L2_NETWORK_NAME || "L2"}</button> :
              checkDisabled ? <button className='btn deposit_btn' disabled={true}>Withdraw</button> :
                <button className='btn deposit_btn' onClick={handleWithdraw} disabled={loader ? true : false}>{loader ? <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner> : "Withdraw"}</button>}
          </div>
          {metaMastError && <small className="d-block text-danger text-center mt-2">{metaMastError}</small>}
        </section>
      </div>
    </>
  )
}

export default Withdraw
